import { render, staticRenderFns } from "./VirtualAccountTransactions.vue?vue&type=template&id=7e7a097c&"
import script from "./VirtualAccountTransactions.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountTransactions.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports